<template>
    <div v-html="payUrl"></div>
</template>
<script>
import { wxRequest } from '@/api/user'
import { Dialog } from 'vant';
export default {
    data() {
        return {
            payUrl: '',
            orderNo: ''
        }
    },
    async created() {
        this.init()
    },
    methods: {
        async init() {
            var source = this.getQueryVariable('source') ? this.getQueryVariable('source') : process.env.VUE_APP_APPID;
            var appid = source ? source : process.env.VUE_APP_APPID;
            await wxRequest("/sim/appId", {}, "post").then(res => {
                if (res.data.code == 200) {
                    appid = res.data.data.collectAppid;
                }
            });
            localStorage.setItem('isHeadquarterAppid', true);
            localStorage.setItem('appid', source);
            var redirectUrl = window.location.href;
            var index = redirectUrl.indexOf('code');
            redirectUrl = encodeURIComponent(redirectUrl);
            if (index < 0) {
                window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_base#wechat_redirect`;
            } else {
                var search = window.location.search;
                var startIndex = search.indexOf('code');
                var endIndex = search.indexOf('&', startIndex);
                var str = search.slice(startIndex, endIndex);
                var code = str.slice(str.indexOf('=') + 1);
                wxRequest("order/get/payInfo", { orderNo: this.$route.query.orderNo, code: code }, "post").then(res => {
                    if (res.data.code == 400) {
                        Dialog.alert({ title: '提示', message: res.data.message });
                    } else if (res.data.code == 198||res.data.code == 197) { //斗洪支付 || 易宝支付
                        var param = res.data.data;
                        if (typeof WeixinJSBridge == "undefined") {
                            if (document.addEventListener) {
                                document.addEventListener(
                                    "WeixinJSBridgeReady",
                                    this.onBridgeReady,
                                    false
                                );
                            } else if (document.attachEvent) {
                                document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
                                document.attachEvent(
                                    "onWeixinJSBridgeReady",
                                    this.onBridgeReady
                                );
                            }
                        } else {
                            this.onBridgeReady(param);
                        }
                    } else if (res.data.code == 199) { //微信支付
                        var param = res.data.data.param;
                        if (typeof WeixinJSBridge == "undefined") {
                            if (document.addEventListener) {
                                document.addEventListener(
                                    "WeixinJSBridgeReady",
                                    this.onBridgeReady,
                                    false
                                );
                            } else if (document.attachEvent) {
                                document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
                                document.attachEvent(
                                    "onWeixinJSBridgeReady",
                                    this.onBridgeReady
                                );
                            }
                        } else {
                            this.onBridgeReady(param);
                        }
                    } else if (res.data.code == 200) { //乐刷支付
                        window.location.href = res.data.data.jspay_url;
                    }
                })

            }



        },

        //流量套餐充值时唤起微信支付
        onBridgeReady(param) {
            let _this = this;
            WeixinJSBridge.invoke("getBrandWCPayRequest", param, function (res) {
                if (res.err_msg == "get_brand_wcpay_request:ok") {
                    Dialog.alert({ title: "充值成功提示", message: '您已成功充值完订单，请前往APP内查询详情。' });
                }
            });
        },
        //获取url参数
        getQueryVariable(variable){
           var query = window.location.search.substring(1);
           var vars = query.split("&");
           for (var i=0;i<vars.length;i++) {
                   var pair = vars[i].split("=");
                   if(pair[0] == variable){return pair[1];}
           }
           return false;
        },
    }
}
</script>
